// removed by extract-text-webpack-plugin
module.exports = {"container":"_1YA61","expanded":"_2oJrd","isFullWidth":"_2ofor","icon":"_3OsMD","input":"_27Nue","placeholder":"_2t1ih","spacer":"_2Sp96","border":"_3amb6","clear":"_1A6qR","clearIcon":"_3nxMu"};


//////////////////
// WEBPACK FOOTER
// ./app/components/search-input/search-input.scss
// module id = 1631
// module chunks = 0